<template>
    <l-marker :lat-lng="latLong()">
        <l-icon v-if="!$func.isEmpty(icone)" 
            :icon-url="icone"
            :icon-size="[32,38]"
            :icon-anchor="[16,38]"
            :popup-anchor="[0,-37]" />
            <l-popup v-if="!$func.isEmpty(texto)">{{texto}}</l-popup>
    </l-marker>
</template>

<script>
import { LMarker, LIcon, LPopup } from 'vue2-leaflet';

export default {
    props:{
        lat:{
            type: Number,
            required: true,
            default: 0
        },
        long:{
            type: Number,
            required: true,
            default: 0
        },
        icone:{
            type: String,
            default: ""
        },
        texto:{
            type: String,
            default: ""
        },
    },
    components: { LMarker, LIcon, LPopup },
    methods: {
        latLong() {
            return [this.lat, this.long];
        }
    }
}
</script>